import React from 'react';
import { FaCheck, FaTimes, FaClock, FaCheckCircle } from 'react-icons/fa';

function AttendeesTab({ rsvps }) {
  const attending = rsvps.filter(r => r.status === 'attending' || r.response === 'attending');
  const maybe = rsvps.filter(r => r.status === 'maybe' || r.response === 'maybe');
  const notAttending = rsvps.filter(r => r.status === 'not_attending' || r.response === 'not_attending');

  return (
    <div className="space-y-6" data-testid="attendees-tab">
      {/* Attending */}
      <div className="bg-white rounded-xl shadow-md p-6">
        <h3 className="text-lg font-bold text-gray-800 mb-4 flex items-center">
          <FaCheckCircle className="text-green-600 mr-2" />
          Attending ({attending.length})
        </h3>
        {attending.length === 0 ? (
          <p className="text-gray-600">No confirmations yet</p>
        ) : (
          <div className="grid md:grid-cols-2 gap-3">
            {attending.map((rsvp) => (
              <div key={rsvp.rsvp_id} className="flex items-center space-x-2" data-testid={`attendee-${rsvp.rsvp_id}`}>
                <FaCheck className="text-green-600" />
                <span className="text-gray-800">{rsvp.user_name}</span>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Maybe */}
      {maybe.length > 0 && (
        <div className="bg-white rounded-xl shadow-md p-6">
          <h3 className="text-lg font-bold text-gray-800 mb-4 flex items-center">
            <FaClock className="text-yellow-600 mr-2" />
            Maybe ({maybe.length})
          </h3>
          <div className="grid md:grid-cols-2 gap-3">
            {maybe.map((rsvp) => (
              <div key={rsvp.rsvp_id} className="flex items-center space-x-2">
                <FaClock className="text-yellow-600" />
                <span className="text-gray-800">{rsvp.user_name}</span>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Not Attending */}
      {notAttending.length > 0 && (
        <div className="bg-white rounded-xl shadow-md p-6">
          <h3 className="text-lg font-bold text-gray-800 mb-4 flex items-center">
            <FaTimes className="text-red-600 mr-2" />
            Not Attending ({notAttending.length})
          </h3>
          <div className="grid md:grid-cols-2 gap-3">
            {notAttending.map((rsvp) => (
              <div key={rsvp.rsvp_id} className="flex items-center space-x-2">
                <FaTimes className="text-red-600" />
                <span className="text-gray-800">{rsvp.user_name}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

export default AttendeesTab;
